import { render, staticRenderFns } from "./ExamMultipleChoice.vue?vue&type=template&id=73cf8cbc&"
import script from "./ExamMultipleChoice.vue?vue&type=script&lang=js&"
export * from "./ExamMultipleChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports